import { hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import App from './App';
import { clientI18n, clientI18nReady } from './i18n/client';

const DEV_SERVER_BASENAME = '/theme';

if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
}

function hydrate() {
    hydrateRoot(
        document.getElementById('root')!,
        <I18nextProvider i18n={clientI18n}>
            <BrowserRouter basename={import.meta.env.DEV ? DEV_SERVER_BASENAME : undefined}>
                <App />
            </BrowserRouter>
        </I18nextProvider>
    );
}

clientI18nReady.then(hydrate, hydrate);
